if (!customElements.get('price-range')) {
    customElements.define('price-range', class PriceRange extends HTMLElement {
      constructor() {
        super();
        this.minInput = this.querySelector('#price-range-number-min');
        this.maxInput = this.querySelector('#price-range-number-max');
        this.minSlider = this.querySelector('#price-range-slider-min');
        this.maxSlider = this.querySelector('#price-range-slider-max');
        
        this.min = parseFloat(this.dataset.min);
        this.max = parseFloat(this.dataset.max);

        this.setupListeners();
      }

      setupListeners() {
        this.minInput.addEventListener('input', () => this.updateFromInput('min'));
        this.maxInput.addEventListener('input', () => this.updateFromInput('max'));
        this.minSlider.addEventListener('input', () => this.updateFromSlider('min'));
        this.maxSlider.addEventListener('input', () => this.updateFromSlider('max'));
      }

      updateFromInput(type) {
        const value = parseFloat(type === 'min' ? this.minInput.value : this.maxInput.value);
        
        if (type === 'min') {
          const maxVal = parseFloat(this.maxInput.value) || this.max;
          const validValue = Math.min(value, maxVal);
          this.minSlider.value = validValue;
        } else {
          const minVal = parseFloat(this.minInput.value) || this.min;
          const validValue = Math.max(value, minVal);
          this.maxSlider.value = validValue;
        }
        
        this.dispatchFilterEvent();
      }

      updateFromSlider(type) {
        if (type === 'min') {
          const maxVal = parseFloat(this.maxSlider.value);
          if (parseFloat(this.minSlider.value) > maxVal) {
            this.minSlider.value = maxVal;
          }
          this.minInput.value = this.minSlider.value;
        } else {
          const minVal = parseFloat(this.minSlider.value);
          if (parseFloat(this.maxSlider.value) < minVal) {
            this.maxSlider.value = minVal;
          }
          this.maxInput.value = this.maxSlider.value;
        }
        
        this.dispatchFilterEvent();
      }

      dispatchFilterEvent() {
        this.dispatchEvent(new CustomEvent('price-range-change', {
          bubbles: true,
          detail: {
            min: parseFloat(this.minInput.value) || this.min,
            max: parseFloat(this.maxInput.value) || this.max
          }
        }));
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    const filterPro = document.getElementById('filter-pro');
    const filterReconditionne = document.getElementById('filter-reconditionne');
    const filterVendorCheckboxes = document.querySelectorAll('.filter-vendor-checkbox');
    const priceRange = document.querySelector('price-range');
    const productItems = document.querySelectorAll('.product-item');
    const collectionBlocks = document.querySelectorAll('.collection-block');
    const activeFiltersBlock = document.getElementById('active-filters');
    const activeFiltersCount = document.getElementById('active-filters-count');
    const activeFiltersList = document.getElementById('active-filters-list');
    const clearAllFiltersBtn = document.getElementById('clear-all-filters');
    const activeFiltersHeader = document.querySelector('.active-filters-header');
    const collectionFilterCards = document.querySelectorAll('.collection-filter-card');
    let selectedCollectionFilter = null;

    // Gestion du scroll des vignettes (carrousel)
    const collectionsGrid = document.querySelector('.collection-filters-grid');
    if (collectionsGrid) {
      let isDown = false;
      let startX;
      let scrollLeft;

      // Support du drag pour desktop
      collectionsGrid.addEventListener('mousedown', (e) => {
        isDown = true;
        collectionsGrid.style.cursor = 'grabbing';
        startX = e.pageX - collectionsGrid.offsetLeft;
        scrollLeft = collectionsGrid.scrollLeft;
      });

      collectionsGrid.addEventListener('mouseleave', () => {
        isDown = false;
        collectionsGrid.style.cursor = 'grab';
      });

      collectionsGrid.addEventListener('mouseup', () => {
        isDown = false;
        collectionsGrid.style.cursor = 'grab';
      });

      collectionsGrid.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - collectionsGrid.offsetLeft;
        const walk = (x - startX) * 2;
        collectionsGrid.scrollLeft = scrollLeft - walk;
      });

      // Désactiver le drag sur les cartes pour permettre le clic
      collectionFilterCards.forEach(card => {
        card.addEventListener('dragstart', (e) => {
          e.preventDefault();
        });
      });
    }

    // Gestion des filtres par collection (vignettes)
    collectionFilterCards.forEach(card => {
      card.addEventListener('click', function() {
        const collectionHandle = this.dataset.collectionFilter;
        
        // Toggle selection
        if (selectedCollectionFilter === collectionHandle) {
          selectedCollectionFilter = null;
          this.classList.remove('active');
        } else {
          // Retirer la classe active de toutes les cartes
          collectionFilterCards.forEach(c => c.classList.remove('active'));
          // Ajouter la classe active à la carte cliquée
          selectedCollectionFilter = collectionHandle;
          this.classList.add('active');
        }
        
        applyFilters();
      });
    });

    // Mobile filter toggle
    const mobileFilterToggle = document.getElementById('mobile-filter-toggle');
    const filtersSidebar = document.getElementById('filters-sidebar');
    const mobileFilterOverlay = document.getElementById('mobile-filter-overlay');
    const mobileApplyBtn = document.getElementById('mobile-apply-filters');
    const mobileResultsCount = document.getElementById('mobile-results-count');

    // Ouvrir les filtres sur mobile
    if (mobileFilterToggle) {
      mobileFilterToggle.addEventListener('click', function() {
        filtersSidebar.classList.add('active');
        mobileFilterOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    }

    // Fermer les filtres sur mobile
    function closeMobileFilters() {
      filtersSidebar.classList.remove('active');
      mobileFilterOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (mobileFilterOverlay) {
      mobileFilterOverlay.addEventListener('click', closeMobileFilters);
    }

    // Fermer via le X (pseudo-element)
    if (filtersSidebar) {
      filtersSidebar.addEventListener('click', function(e) {
        const rect = this.getBoundingClientRect();
        const clickX = e.clientX;
        const clickY = e.clientY;
        
        // Zone cliquable du X : coin supérieur droit de la sidebar
        if (clickX > rect.right - 80 && clickX < rect.right && clickY > rect.top && clickY < rect.top + 80) {
          closeMobileFilters();
        }
      });
    }

    // Appliquer les filtres et fermer sur mobile
    if (mobileApplyBtn) {
      mobileApplyBtn.addEventListener('click', function() {
        closeMobileFilters();
      });
    }

    // Gestion de l'accordéon des filtres actifs
    if (activeFiltersHeader) {
      activeFiltersHeader.addEventListener('click', function() {
        activeFiltersBlock.classList.toggle('collapsed');
      });
    }

    // Gestion des accordéons
    const filterHeaders = document.querySelectorAll('.filter-header');
    filterHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const filterGroup = this.closest('.filter-group');
        filterGroup.classList.toggle('collapsed');
      });
    });

    // Gestion des boutons "Afficher plus"
    const showMoreBtns = document.querySelectorAll('.show-more-btn');
    showMoreBtns.forEach(btn => {
      const target = btn.dataset.target;
      const checkboxContainer = document.querySelector(`[data-filter-content="${target}"] .filter-checkboxes`);
      
      if (checkboxContainer && target === 'vendor') {
        // Pour les vendors, on limite à 7 éléments au départ
        checkboxContainer.classList.add('show-limited');
        
        btn.addEventListener('click', function() {
          if (checkboxContainer.classList.contains('show-limited')) {
            checkboxContainer.classList.remove('show-limited');
            this.textContent = 'Afficher moins';
          } else {
            checkboxContainer.classList.add('show-limited');
            this.textContent = 'Afficher plus';
          }
        });
      }
    });

    function updateActiveFilters() {
      const activeFilters = [];
      
      // Collection sélectionnée
      if (selectedCollectionFilter) {
        const activeCard = document.querySelector(`.collection-filter-card[data-collection-filter="${selectedCollectionFilter}"]`);
        const collectionTitle = activeCard ? activeCard.dataset.collectionTitle : '';
        
        activeFilters.push({
          type: 'collection',
          value: selectedCollectionFilter,
          label: collectionTitle,
          card: activeCard
        });
      }
      
      // Vendors sélectionnés
      filterVendorCheckboxes.forEach(cb => {
        if (cb.checked) {
          activeFilters.push({
            type: 'vendor',
            value: cb.value,
            label: cb.value,
            element: cb
          });
        }
      });

      // Prix
      const minPrice = parseFloat(priceRange.querySelector('#price-range-number-min').value);
      const maxPrice = parseFloat(priceRange.querySelector('#price-range-number-max').value);
      const rangeMin = parseFloat(priceRange.dataset.min);
      const rangeMax = parseFloat(priceRange.dataset.max);
      
      if (minPrice > rangeMin || maxPrice < rangeMax) {
        activeFilters.push({
          type: 'price',
          label: `Prix: ${minPrice}€ - ${maxPrice}€`,
          minInput: priceRange.querySelector('#price-range-number-min'),
          maxInput: priceRange.querySelector('#price-range-number-max'),
          minSlider: priceRange.querySelector('#price-range-slider-min'),
          maxSlider: priceRange.querySelector('#price-range-slider-max'),
          rangeMin: rangeMin,
          rangeMax: rangeMax
        });
      }

      // Pro
      if (filterPro.checked) {
        activeFilters.push({
          type: 'pro',
          label: 'Matériel pour professionnels: Oui',
          element: filterPro
        });
      }

      // Reconditionné
      if (filterReconditionne.checked) {
        activeFilters.push({
          type: 'reconditionne',
          label: 'Reconditionné',
          element: filterReconditionne
        });
      }

      // Mettre à jour l'affichage
      if (activeFilters.length > 0) {
        activeFiltersBlock.style.display = 'block';
        activeFiltersCount.textContent = `${activeFilters.length} FILTRE${activeFilters.length > 1 ? 'S' : ''} APPLIQUÉ${activeFilters.length > 1 ? 'S' : ''}`;
        
        activeFiltersList.innerHTML = '';
        activeFilters.forEach(filter => {
          const tag = document.createElement('div');
          tag.className = 'active-filter-tag';
          tag.innerHTML = `
            <button type="button" class="active-filter-remove" data-filter-type="${filter.type}" data-filter-value="${filter.value || ''}"></button>
            <span>${filter.label}</span>
          `;
          
          // Ajouter l'événement de suppression
          const removeBtn = tag.querySelector('.active-filter-remove');
          removeBtn.addEventListener('click', function() {
            if (filter.type === 'collection') {
              selectedCollectionFilter = null;
              if (filter.card) {
                filter.card.classList.remove('active');
              }
            } else if (filter.type === 'vendor') {
              filter.element.checked = false;
            } else if (filter.type === 'price') {
              filter.minInput.value = filter.rangeMin;
              filter.maxInput.value = filter.rangeMax;
              filter.minSlider.value = filter.rangeMin;
              filter.maxSlider.value = filter.rangeMax;
            } else {
              filter.element.checked = false;
            }
            applyFilters();
          });
          
          activeFiltersList.appendChild(tag);
        });
      } else {
        activeFiltersBlock.style.display = 'none';
      }
    }

    function clearAllFilters() {
      // Décocher tous les vendors
      filterVendorCheckboxes.forEach(cb => cb.checked = false);
      
      // Réinitialiser le prix
      const rangeMin = parseFloat(priceRange.dataset.min);
      const rangeMax = parseFloat(priceRange.dataset.max);
      priceRange.querySelector('#price-range-number-min').value = rangeMin;
      priceRange.querySelector('#price-range-number-max').value = rangeMax;
      priceRange.querySelector('#price-range-slider-min').value = rangeMin;
      priceRange.querySelector('#price-range-slider-max').value = rangeMax;
      
      // Décocher pro et reconditionné
      filterPro.checked = false;
      filterReconditionne.checked = false;
      
      // Réinitialiser le filtre collection
      selectedCollectionFilter = null;
      collectionFilterCards.forEach(c => c.classList.remove('active'));
      
      applyFilters();
    }

    clearAllFiltersBtn.addEventListener('click', clearAllFilters);

    function applyFilters() {
      const selectedVendors = Array.from(filterVendorCheckboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.value.toLowerCase());
      
      const minPrice = parseFloat(priceRange.querySelector('#price-range-number-min').value) || parseFloat(priceRange.dataset.min);
      const maxPrice = parseFloat(priceRange.querySelector('#price-range-number-max').value) || parseFloat(priceRange.dataset.max);
      
      const showOnlyPro = filterPro.checked;
      const showOnlyReconditionne = filterReconditionne.checked;

      let visibleCount = 0;
      const collectionCounts = {};

      // Filtrer les produits
      productItems.forEach(item => {
        const vendor = item.dataset.vendor.toLowerCase();
        const price = parseFloat(item.dataset.price);
        const isPro = item.dataset.pro === 'true';
        const isReconditionne = item.dataset.reconditionne === 'true';
        const productSubcollections = item.dataset.productSubcollections ? item.dataset.productSubcollections.split(',').filter(s => s) : [];

        let shouldShow = true;

        // Filtre subcollection (vignettes) - filtre les PRODUITS maintenant
        if (selectedCollectionFilter && !productSubcollections.includes(selectedCollectionFilter)) {
          shouldShow = false;
        }

        // Filtre vendor
        if (selectedVendors.length > 0 && !selectedVendors.includes(vendor)) {
          shouldShow = false;
        }

        // Filtre prix
        if (price < minPrice || price > maxPrice) {
          shouldShow = false;
        }

        // Filtre pro
        if (showOnlyPro && !isPro) {
          shouldShow = false;
        }

        // Filtre reconditionné
        if (showOnlyReconditionne && !isReconditionne) {
          shouldShow = false;
        }

        if (shouldShow) {
          item.classList.remove('hidden');
          visibleCount++;

          // Compter par collection
          const collectionBlock = item.closest('.collection-block');
          const collectionId = collectionBlock.dataset.collectionId;
          collectionCounts[collectionId] = (collectionCounts[collectionId] || 0) + 1;
        } else {
          item.classList.add('hidden');
        }
      });

      // Masquer les collections qui n'ont plus de produits visibles
      document.querySelectorAll('.collection-block').forEach(block => {
        const collectionId = block.dataset.collectionId;
        if (collectionCounts[collectionId]) {
          block.style.display = 'block';
        } else {
          block.style.display = 'none';
        }
      });

      // Mettre à jour les filtres actifs
      updateActiveFilters();

      // Mettre à jour le compteur mobile
      if (mobileResultsCount) {
        mobileResultsCount.textContent = visibleCount;
      }
    }

    // Event listeners
    filterVendorCheckboxes.forEach(cb => {
      cb.addEventListener('change', applyFilters);
    });
    
    priceRange.addEventListener('price-range-change', applyFilters);
    filterPro.addEventListener('change', applyFilters);
    filterReconditionne.addEventListener('change', applyFilters);

    // Initialisation
    applyFilters();
  });